import {
    GET_NODES_SERVICE_REQUEST,
    GET_NODES_SERVICE_SUCCESS,
    GET_NODES_SERVICE_FAILURE,
    GET_NODE_BY_ID_SERVICE_REQUEST,
    GET_NODE_BY_ID_SERVICE_SUCCESS,
    GET_NODE_BY_ID_SERVICE_FAILURE,
    UPDATE_NODE_STATUS_SERVICE_REQUEST,
    UPDATE_NODE_STATUS_SERVICE_SUCCESS,
    UPDATE_NODE_STATUS_SERVICE_FAILURE,
    DELETE_NODE_SERVICE_REQUEST,
    DELETE_NODE_SERVICE_SUCCESS,
    DELETE_NODE_SERVICE_FAILURE,
    CHECK_NODE_HEALTH_SERVICE_REQUEST,
    CHECK_NODE_HEALTH_SERVICE_SUCCESS,
    CHECK_NODE_HEALTH_SERVICE_FAILURE,
  } from "./actions";
  
  const initialState = {
    nodes: [],
    selectedNode: null,
    loading: false,
    error: null,
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    nodeHealth: [],
  };
  
  export default function nodeReducer(state = initialState, action) {
    switch (action.type) {
      // Node listesi
      case GET_NODES_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_NODES_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          nodes: action.payload,
          totalCount: action.payload.totalCount,
          currentPage: action.payload.currentPage,
          pageSize: action.payload.pageSize,
        };
      case GET_NODES_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Tek bir node getirme
      case GET_NODE_BY_ID_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_NODE_BY_ID_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          selectedNode: action.payload,
        };
      case GET_NODE_BY_ID_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Node durumu güncelleme
      case UPDATE_NODE_STATUS_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case UPDATE_NODE_STATUS_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          nodes: state.nodes.map((node) =>
            node.id === action.payload.id
              ? { ...node, status: action.payload.status }
              : node
          ),
        };
      case UPDATE_NODE_STATUS_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Node silme
      case DELETE_NODE_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case DELETE_NODE_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          nodes: state.nodes.filter(
            (node) => node.id !== action.payload
          ),
          totalCount: state.totalCount - 1,
        };
      case DELETE_NODE_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Node sağlık kontrolü
      case CHECK_NODE_HEALTH_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case CHECK_NODE_HEALTH_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          nodeHealth: action.payload,
        };
      case CHECK_NODE_HEALTH_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  } 